








import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
})
export default class BlobImageViewer extends Mixins() {
  private _blobUrl: any;
  private _image: HTMLImageElement;

  @Prop()
  source: any;

  mounted(): void {
    this._image = new Image();
    this._image.onload = () => {
      // TODO:読み込みエラーになったときにもちゃんと開放される？
      this.clearBlobUrl();
      this.updateImage();
    };
    if (this.source) {
      this.setBlobUrl();
    }
  }

  @Watch("source")
  setBlobUrl(): void {
    this.clearBlobUrl();
    if (this.source) {
      this._blobUrl = URL.createObjectURL(this.source);
      this._image.src = this._blobUrl;
    }
  }

  clearBlobUrl() {
    if (this._blobUrl) {
      URL.revokeObjectURL(this._blobUrl);
      this._blobUrl = null;
    }
  }

  updateImage(): void {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    if (!canvas) { return; }
    this.drawImageToCanvas(this._image, canvas);
  }

  drawImageToCanvas(image: HTMLImageElement, canvas: HTMLCanvasElement): void {
    if (!canvas) { return; }
    const context = canvas.getContext("2d");
    if (!context) { return; }
    const rect = canvas.getBoundingClientRect();
    const ratioByWidth = rect.width / image.width;
    const ratioByHeight = rect.height / image.height;
    const ratio = (image.height * ratioByWidth <= rect.height) ? ratioByWidth : ratioByHeight;
    const drawWidth = Math.floor(image.width * ratio);
    const drawHeight = Math.floor(image.height * ratio);
    context.drawImage(image, 0, 0, drawWidth, drawHeight);
  }

  onDragOver(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
  }

  onDrop(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();

    try {
      const text = event.dataTransfer.getData("text");
      if (text) { return; }
      const file = event.dataTransfer.files[0];
      if (file.type.indexOf("image/") !== 0) { return; }
      this.$emit("fileDrop", file);
    } catch (e) {
      console.warn(e);
    }
  }
}
